"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateBusinessRequestToJSON = exports.CreateBusinessRequestFromJSONTyped = exports.CreateBusinessRequestFromJSON = exports.instanceOfCreateBusinessRequest = void 0;
var runtime_1 = require("../runtime");
var BusinessType_1 = require("./BusinessType");
/**
 * Check if a given object implements the CreateBusinessRequest interface.
 */
function instanceOfCreateBusinessRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "businessAdminName" in value;
    isInstance = isInstance && "businessAdminEmail" in value;
    isInstance = isInstance && "businessAdminHasMarketingOptIn" in value;
    return isInstance;
}
exports.instanceOfCreateBusinessRequest = instanceOfCreateBusinessRequest;
function CreateBusinessRequestFromJSON(json) {
    return CreateBusinessRequestFromJSONTyped(json, false);
}
exports.CreateBusinessRequestFromJSON = CreateBusinessRequestFromJSON;
function CreateBusinessRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'businessAdminName': json['business_admin_name'],
        'businessAdminEmail': json['business_admin_email'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : (0, BusinessType_1.BusinessTypeFromJSON)(json['type']),
        'businessAdminHasMarketingOptIn': json['business_admin_has_marketing_opt_in'],
    };
}
exports.CreateBusinessRequestFromJSONTyped = CreateBusinessRequestFromJSONTyped;
function CreateBusinessRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'business_admin_name': value.businessAdminName,
        'business_admin_email': value.businessAdminEmail,
        'type': (0, BusinessType_1.BusinessTypeToJSON)(value.type),
        'business_admin_has_marketing_opt_in': value.businessAdminHasMarketingOptIn,
    };
}
exports.CreateBusinessRequestToJSON = CreateBusinessRequestToJSON;
